module.exports = __webpack_public_path__ + "4419fa8e6bf76e821687cdc9a3cd3d5f.png";